// extracted by mini-css-extract-plugin
module.exports = {"simpleFooter":"styles_simpleFooter__d82ua","container":"styles_container__WTfLt","copyright":"styles_copyright__lApjE"};